/**
 * Map location query to location search
 * @param query - location query obj
 * @return {string}
 */
export const queryToSearch = query =>
  Object.keys(query).reduce((acc, key) => `${acc === '?' ? acc : `${acc}&`}${key}=${query[key]}`, '?');
